import { SalesforceApiClient } from "./salesforceApiClient";

export interface SetLanguageParams {
    language: string;
    salesforceApiClient: SalesforceApiClient;
}

export interface Language {
    label: string;
    typo3Locale: string;
    typo3LocaleId: string;
}

export interface Languages {
    [key: string]: Language;
}

/** those languages are available in Salesforce, the values for TYPO3 are often different */
export const availableLanguages: Languages = {
    de: { label: "Deutsch", typo3Locale: "de_DE", typo3LocaleId: "7" },
    en_US: { label: "English", typo3Locale: "en_US", typo3LocaleId: "10" },
    fr: { label: "Français", typo3Locale: "fr_FR", typo3LocaleId: "16" },
    it: { label: "Italiano", typo3Locale: "it_IT", typo3LocaleId: "14" },
    es: { label: "Español", typo3Locale: "es_ES", typo3LocaleId: "23" },
    pt_PT: { label: "Português", typo3Locale: "pt_PT", typo3LocaleId: "36" },
    zh_CN: { label: "中文", typo3Locale: "zh_CN", typo3LocaleId: "30" },
    ja: { label: "日本語", typo3Locale: "ja_JP", typo3LocaleId: "18" },
    ko: { label: "한국어", typo3Locale: "ko_KR", typo3LocaleId: "6" },
    nl: { label: "Nederlands", typo3Locale: "nl_NL", typo3LocaleId: "15" },
    pl: { label: "Polski", typo3Locale: "pl_PL", typo3LocaleId: "19" },
    cs: { label: "Český", typo3Locale: "cs_CZ", typo3LocaleId: "24" },
    hu: { label: "Magyar", typo3Locale: "hu_HU", typo3LocaleId: "26" },
    // pt_BR: { label: "Português (BR)", typo3Locale: "pt_BR", typo3LocaleId: "27" }, // should not be used
    // zh_TW: { label: "中文 (TW)", typo3Locale: "zh_TW", typo3LocaleId: "28" }, // should not be used
    // sv: { label: "Svenska", typo3Locale: "sv_SE", typo3LocaleId: "21" },
    // da: { label: "Dansk", typo3Locale: "", typo3LocaleId: "" }, // does not exist in TYPO3
    // th: { label: "ไทย", typo3Locale: "th_TH", typo3LocaleId: "34" }, // should not be used
    // fi: { label: "Suomi", typo3Locale: "", typo3LocaleId: "" }, // does not exist in TYPO3
    // ru: { label: "Русский", typo3Locale: "", typo3LocaleId: "" }, // does not exist in TYPO3
    // es_MX: { label: "Español (MX)", typo3Locale: "es_MX", typo3LocaleId: "39" }, // should not be used
    // no: { label: "Norsk", typo3Locale: "", typo3LocaleId: "" }, // does not exist in TYPO3
};

export const getLanguage = (locale: string): Language => {
    return availableLanguages[locale] || availableLanguages.en_US;
};

export const setLanguage = ({
    language,
    salesforceApiClient,
}: SetLanguageParams) => {
    const { baseUrl, apiVersion } =
        salesforceApiClient.getSalesforceApiConfig();
    const idTokenData = salesforceApiClient.getIdTokenData();
    const userId = idTokenData?.custom_attributes?.attr_id;
    if (!userId) {
        return Promise.resolve();
    }
    const url = `${baseUrl}/services/data/v${apiVersion}/sobjects/User/${userId}`;
    return salesforceApiClient
        .request(url, {
            method: "PATCH",
            body: {
                LanguageLocaleKey: language,
            },
        })
        .catch((error) => {
            if (error.status === 204) {
                // 204 means success but no content
                return;
            }
        });
};
